<h3 mat-dialog-title>{{ title }}</h3>

<mat-dialog-content>
    <app-sms-auth-setup-step (completed)="onCompleted()"
                             (showingRecoveryCodes)="onShowingRecoveryCodes()"
                             (cancelled)="onCancelled()"></app-sms-auth-setup-step>
</mat-dialog-content>
